import React from "react";
import { motion } from "framer-motion";
import {
  FaCertificate,
  FaUsers,
  FaLaptopCode,
  FaChalkboardTeacher,
} from "react-icons/fa";
import "./TeachingCareerSection.css";
import teacherImg from "../../assets/DSC_3043.png";

const TeachingCareerSection = () => {
  const features = [
    {
      icon: <FaCertificate />,
      title: "Certification & Placement Assistance",
      color: "#ee5951",
    },
    {
      icon: <FaLaptopCode />,
      title: "Value Added Programs (VAPs)",
      color: "rgb(0, 102, 205)",
    },
    {
      icon: <FaUsers />,
      title: "Strong Alumni Network",
      color: "#ee5951",
    },
    {
      icon: <FaChalkboardTeacher />,
      title: "Online & Regular Batches",
      color: "rgb(0, 102, 205)",
    },
  ];

  return (
    <section className="career-section">
      <div className="container career-container">
        {/* Left: Text Section */}
        <motion.div
          className="career-text"
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="career-title">
            Get Started on Your Teaching Career,
            <br />
            <span className="highlight">The NIECCE Way!</span>
          </h2>

          <p className="career-desc">
            NIECCE is one of India’s top teacher training institutes offering
            comprehensive Diploma Programs in Nursery, Montessori, and Primary
            Teacher Training. Our programs empower aspiring educators with the
            right knowledge, practical exposure, and placement support to become
            confident, compassionate, and innovative teachers.
          </p>

          <div className="career-features">
            {features.map((item, index) => (
              <motion.div
                key={index}
                className="feature-card"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
              >
                <div
                  className="feature-icon"
                  style={{ color: item.color }}
                >
                  {item.icon}
                </div>
                <h4>{item.title}</h4>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Right: Image Section */}
        <motion.div
          className="career-image"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <img
            src={teacherImg}
            alt="Teacher training classroom at NIECCE"
            title="Teacher training classroom at NIECCE"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default TeachingCareerSection;
